<template>
	<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
		<slot/>
	</div>
</template>
<script setup lang="ts"></script>